import { useState } from 'react'
import AdminLayout from '../components/AdminLayout'
import ClubProfile from './components/ClubProfile'
import BrandingForm from './components/BrandingForm'
import ExecutivesForm from './components/ExecutivesForm'
import AdminProfileForm from './components/AdminProfileForm'

const TABS = [
  { id: 'profile', label: 'Profile' },
  { id: 'club', label: 'Club' },
  { id: 'branding', label: 'Branding' },
  { id: 'executives', label: 'Executives' },
]

export default function AdminSettings() {
  const [activeTab, setActiveTab] = useState('profile')

  return (
    <AdminLayout>
      <div className="mb-6 lg:mb-8">
        <h1 className="text-2xl lg:text-4xl font-black uppercase tracking-tight mb-2 text-gray-900 dark:text-white">
          Settings
        </h1>
        <p className="text-gray-500 text-sm">Manage your profile, club, branding, and executives</p>
      </div>

      {/* Tab Bar */}
      <div className="flex gap-0 border-b border-gray-200 dark:border-white/10 mb-6 overflow-x-auto">
        {TABS.map(tab => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`px-5 py-3 text-xs font-bold uppercase tracking-widest whitespace-nowrap transition-colors border-b-2 -mb-px ${
              activeTab === tab.id
                ? 'border-green-600 text-green-600 dark:text-green-400'
                : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      {activeTab === 'profile' && <AdminProfileForm />}
      {activeTab === 'club' && <ClubProfile />}
      {activeTab === 'branding' && <BrandingForm />}
      {activeTab === 'executives' && <ExecutivesForm />}
    </AdminLayout>
  )
}